<template>
  <v-container
    fluid
    class="pa-0 ma-0 d-flex flex-column justify-space-between"
    style="height: 85vh; border-radius: 4px; background: #FFF; !important;"
    elevation-3
  >
    <NewCi :new_dialog="new_dialog" :closeEditor="closeEditor" :editor_open="editor_open" />
    <v-container fluid class="px-0 pt-0">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text"> Recebidos</v-toolbar-title>
      </v-toolbar>
      <v-container class="pa-4 ma-0">
        <v-btn color="green lighten-1" class="white--text" @click="editor_open = true">
          <v-icon class="mr-2">mdi-plus</v-icon>
          Criar</v-btn
        >
      </v-container>
      <AllCIList />
    </v-container>
  </v-container>
</template>

<script>
import AllCIList from './components/AllCIList'
import NewCi from '../components/NewCi'

export default {
  name: 'Ci',
  components: { AllCIList, NewCi },
  data: function () {
    return {
      new_dialog: false,
      editor_open: false,
    }
  },
  computed: {},
  methods: {
    closeEditor() {
      this.editor_open = false
    },
  },
}
</script>
